import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ForgotPasswordForm } from '@optsolservices/ngx-forgot-password-form';
import { NotificationService } from '@optsolservices/ngx-notification';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {

  constructor(
    private authService: AuthService,
    private notificationService: NotificationService,
    private router: Router,
    ) { }

  async submit(forgotPasswordForm: ForgotPasswordForm): Promise<void> {
    const response = await this.authService.userPasswordChangeRequest(forgotPasswordForm.email).toPromise();
    if (response.responseCode !== 0) { return; }
    this.notificationService.success('An email has been sent with instructions on how to reset your password.');
    this.router.navigate(['/']);
  }
}
